<template>
  <modal class="message-modal" title="预览溯源" buttonsHidden>
    <div class="text-center">
      <h5>请使用手机扫描以下二维码预览溯源页面</h5>
      <p class="mt-10 mb-5"><qrcode :value="url" :size="200" /></p>
    </div>
  </modal>
</template>
<script>
import qrcode from 'qrcode.vue'
export default {
  components: {
    qrcode,
  },
  props: {
    batchID: [String, Number]
  },
  computed: {
    url() {
      return window.__CONFIG__.api + '/t/' + this.batchID + '/demo'
    }
  }
}
</script>